var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvoemmehal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.609,7.987a.361.361,0,0,0,.143,0,.289.289,0,0,0,.282-.264.3.3,0,0,0-.279-.341L8.458,7.2a.312.312,0,0,0-.358.282L7.61,9.408l-1.995,1.38a.83.83,0,0,0,.3.182h.41a.976.976,0,0,0,.353-.23,1.572,1.572,0,0,1,2.25,0,.968.968,0,0,0,.353.23h.2L8.843,8.014Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.845,11.551a.831.831,0,0,1-.627-.287,1.467,1.467,0,0,0-2.107,0,.832.832,0,0,1-1.257,0,1.468,1.468,0,0,0-2.108,0,.834.834,0,0,1-1.259,0,1.472,1.472,0,0,0-2.111,0,.842.842,0,0,1-.63.287.324.324,0,1,0,0,.648A1.467,1.467,0,0,0,3.8,11.753a.834.834,0,0,1,1.261,0,1.468,1.468,0,0,0,2.109,0,.831.831,0,0,1,1.257,0,1.467,1.467,0,0,0,2.108,0,.831.831,0,0,1,1.256,0,1.458,1.458,0,0,0,1.053.447.324.324,0,1,0,0-.648Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.947,5.862A.425.425,0,0,0,3.168,5.8L7.8,3.027,12.422,5.8a.431.431,0,0,0,.444-.74L8.017,2.154a.425.425,0,0,0-.443,0L2.724,5.06a.432.432,0,0,0,.223.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.357,9.892a.719.719,0,1,0-.869-.527A.718.718,0,0,0,10.357,9.892Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvoemmehal);
export default __webpack_public_path__ + "static/media/SVOEMMEHAL.2152a0fb1d9bb03fa3bc981845d82b47.svg";
export { ForwardRef as ReactComponent };